import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { getRuntimeConfig } from 'helpers/runtimeConfig';

const initializer = () => {
  const reactPlugin = new ReactPlugin();
  const ai = new ApplicationInsights({
    config: {
      instrumentationKey: getRuntimeConfig().env.REACT_APP_AZURE_APP_INSIGHTS_KEY,
      extensions: [reactPlugin],
    },
  });
  ai.loadAppInsights();
};

export default initializer;
